/**
 * EventEndedView — Message shown when event has ended
 *
 * Displays a brief "event ended" message. The default lander content
 * is rendered beneath this component by ComingSoonPage (AC-08).
 *
 * @story SCRUM-1450 — 0.1.1.3-02: Render Directive Frontend Integration
 */

import React from 'react';
import PropTypes from 'prop-types';

export default function EventEndedView({ event }) {
  return (
    <div className="bg-gray-100 py-8 px-4 text-center">
      <h2 className="text-xl font-semibold text-gray-900 mb-2">
        {event?.name ? `${event.name} has ended` : 'This event has ended'}
      </h2>
      <p className="text-gray-600 text-sm">
        Thanks for your interest! Check out what&apos;s coming next below.
      </p>
    </div>
  );
}

EventEndedView.propTypes = {
  event: PropTypes.shape({
    name: PropTypes.string,
  }),
};
